module.exports = __webpack_public_path__ + "html/company_59c8f4587756eddac435faf7b0088c7f.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/company.html
// module id = BjDr
// module chunks = 124